/**
 * Хук опроса /api/ai-status (фича 031).
 *
 * Использует TanStack Query polling с refetchInterval из YAML-конфига
 * (`config/constants.yaml: ai_usage.poll_interval_seconds`, по умолчанию 30).
 * staleTime = (poll - 5) сек — окно "ещё свежо, пока не следующий poll".
 *
 * Возвращает `AiStatusEnvelope | undefined`. На ошибке возвращает undefined
 * (статус-индикатор покажет fallback-состояние, не падает).
 */

import type { AiStatusEnvelope } from "@efes/shared";
import { useQuery } from "@tanstack/react-query";
import { getAiStatus } from "@/services/api";

// Фолбэк, если конфиг по какой-то причине не загрузился.
const DEFAULT_POLL_SECONDS = 30;

export function useAiStatus(pollIntervalSeconds: number = DEFAULT_POLL_SECONDS) {
	return useQuery<AiStatusEnvelope>({
		queryKey: ["ai-status"],
		queryFn: getAiStatus,
		refetchInterval: pollIntervalSeconds * 1000,
		staleTime: Math.max((pollIntervalSeconds - 5) * 1000, 0),
		refetchOnWindowFocus: false,
		retry: 1,
	});
}
